import React from "react";
import { AgentConstructionItem } from "@/entities/agent/model/agent.types";
import AgentDataUploader from "@/entities/agent/ui/AgentDataUploader";
import AgentDataUploaderAdd from "@/entities/agent/ui/AgentDataUploaderAdd";
import { useDemoToast } from "@/features/demo/model/useDemoToast";

type AgentItemsUploaderProps = {
  items: AgentConstructionItem[];
  disabled: boolean;
  onUpdateItem: (
    index: number,
    updater: (prevItem: AgentConstructionItem) => AgentConstructionItem
  ) => void;
  onRemoveItem: (index: number) => void;
  onAddItem: () => void;
  onErrorChange: (index: number, error: string | null) => void;
};

const DemoAgentItemsUploader = React.forwardRef<
  HTMLDivElement,
  AgentItemsUploaderProps
>(
  (
    { items, disabled, onUpdateItem, onRemoveItem, onAddItem, onErrorChange },
    ref
  ) => {
    const { showToast } = useDemoToast();
    return (
      <div
        ref={ref}
        className="w-full animate-fade-in overflow-x-auto tablet:pl-[86px] main:pl-[138px]"
      >
        <div className="grid w-full grid-cols-1 gap-[24px] tablet:w-[974px] tablet:grid-cols-[repeat(3,280px)] main:w-full">
          {items.map((item, index) => (
            <AgentDataUploader
              index={index}
              item={item}
              key={`agent-data-uploader-${index}`}
              disabled={disabled}
              updateItem={onUpdateItem}
              removeItem={() => onRemoveItem(index)}
              onErrorChange={onErrorChange}
              showToast={showToast}
            />
          ))}
          {items.length < 3 && <AgentDataUploaderAdd addItem={onAddItem} />}
        </div>
      </div>
    );
  }
);

DemoAgentItemsUploader.displayName = "DemoAgentItemsUploader";

export default DemoAgentItemsUploader;
